import type { CityConfig } from "@/pages/city-template/types";

export const binghamtonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Binghamton",
  state: "New York",
  stateAbbr: "NY",
  slug: "binghamton",
  route: "/binghamton",
  title: "Emergency Passport Binghamton, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Binghamton, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving SUNY Binghamton students, Southern Tier professionals, Lockheed Martin engineers, and Broome County families from Johnson City to Vestal.",
  h1: "Emergency & Expedited Passport Services in Binghamton, NY",
  heroSubtitle: "SUNY Binghamton semester in London starting in 3 weeks? Lockheed Martin contract in the UK departing next month? Family heritage trip to Italy or Poland booked for summer? We help Binghamton residents — from Vestal professors to Johnson City families to Endicott professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Binghamton%20New%20York%20skyline%20along%20the%20Susquehanna%20River%20with%20historic%20downtown%20Court%20Street%20buildings%20and%20the%20iconic%20Art%20Deco%20State%20Office%20Building%2C%20SUNY%20Binghamton%20campus%20green%20hills%20visible%20in%20distance%2C%20warm%20golden%20hour%20autumn%20light%20with%20rich%20foliage%20colors%20reflecting%20on%20the%20river%2C%20professional%20architectural%20photography%20with%20dramatic%20clouds%20and%20clean%20composition%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=binghamton-hero-2026&orientation=landscape",
  heroImageAlt: "Binghamton New York skyline with Susquehanna River and downtown at golden hour",
  geoPosition: "42.0987;-75.9180",
  geoPlacename: "Binghamton, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Approximately 175 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Binghamton", zips: "13901–13905" },
    { name: "Johnson City", zips: "13790" },
    { name: "Vestal", zips: "13850, 13851" },
    { name: "Endicott", zips: "13760, 13761, 13763" },
    { name: "Endwell", zips: "13762" },
    { name: "Conklin", zips: "13748" },
    { name: "Kirkwood", zips: "13795" },
    { name: "Port Dickinson", zips: "13901" },
    { name: "Chenango Bridge", zips: "13745" },
    { name: "Elmira", zips: "14901–14905" },
    { name: "Ithaca", zips: "14850–14853" },
    { name: "Syracuse", zips: "13201–13290" },
    { name: "Albany", zips: "12201–12288" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Southern Tier Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Binghamton-area travelers with immediate departures from BGM or SYR." },
    { icon: "ri-flight-takeoff-line", title: "BGM & Upstate Airport Expertise", desc: "Greater Binghamton Airport connector flights, Syracuse Hancock alternatives — we know Southern Tier airline timelines and last-minute connection scenarios." },
    { icon: "ri-building-2-line", title: "SUNY & Corporate Travel Ready", desc: "Binghamton University study abroad, Lockheed Martin and BAE Systems international contracts, United Health Services global conferences — we handle the passport so you handle the work." },
    { icon: "ri-graduation-cap-line", title: "University + First-Time Family Expedited", desc: "SUNY Binghamton students studying abroad, BU international students returning home, Broome County families booking first international vacations — we guide everyone through." },
  ],
  internalLinks: [
    { name: "Fast passport services in Syracuse, NY", route: "/syracuse" },
    { name: "Expedited passport in Ithaca, NY", route: "/ithaca" },
    { name: "Quick passport services in Elmira, NY", route: "/elmira" },
    { name: "Urgent passport services in Albany, NY", route: "/albany-ny" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Binghamton via secure registered courier with direct access to the New York Passport Agency in Manhattan. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Binghamton residents can ship from any UPS Store, FedEx Office, or post office location across Broome County.",
  fpcOfficeDistance: "Serving Binghamton, Johnson City, Vestal, Endicott, Endwell, and all Southern Tier communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Binghamton and the greater Southern Tier. From the downtown business district along Court Street to the Vestal Parkway commercial corridor, from Johnson City's Oakdale Mall area to Endicott's industrial heritage neighborhoods — we serve all of Broome County and the Twin Tiers. Our courier service eliminates the need to drive to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Binghamton and all Southern Tier communities including Johnson City, Vestal, Endicott, Endwell, Conklin, and Kirkwood. We also serve travelers departing from Greater Binghamton Airport (BGM) and Syracuse Hancock International Airport (SYR) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Binghamton as simple as possible — with the efficiency and reliability Southern Tier professionals, SUNY students, and Broome County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Binghamton travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Binghamton travelers encounter unique passport issues — everything from SUNY study abroad acceptance timelines to Lockheed Martin contract travel to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Binghamton travelers — from Vestal professors to Johnson City families to Endicott engineers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Binghamton, NY? Here are the most common ones we hear from Southern Tier travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a BGM connector flight to Detroit for an international connection, an emergency passport for a last-minute Lockheed Martin contract trip, or a first-time passport for a SUNY Binghamton study abroad semester — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BGM connector flight to Detroit for an international connection in two days? Lockheed Martin contract in the UK this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Binghamton-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Binghamton residents renew fast — no agency visit required for most renewals. Perfect for SUNY professors, Lockheed Martin engineers, and Broome County families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Binghamton residents through every step — from downtown to Vestal to Endicott — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your SUNY semester abroad or Southern Tier business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or Broome County family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Binghamton professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Lockheed Martin and BAE Systems engineers traveling internationally while their primary passport is in visa processing for countries like India, China, or Russia.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Southern Tier travelers through the process so your international itinerary or corporate travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Binghamton residents making quick Toronto weekend trips or Niagara Falls getaways.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Binghamton NY", description: "Urgent passport processing for Binghamton travelers with immediate departure needs from Greater Binghamton Airport or Syracuse." },
    { name: "Expedited Passport Renewal Binghamton NY", description: "Fast passport renewal for Binghamton residents with a previously-issued passport." },
    { name: "First-Time Passport Binghamton NY", description: "New passport application services for Binghamton residents applying for their first passport." },
    { name: "Child Passport Binghamton NY", description: "Minor passport services for Binghamton families with children under 16." },
    { name: "Name Change Passport Binghamton NY", description: "Passport name correction after marriage, divorce, or legal name changes for Binghamton residents." },
    { name: "Second Passport Binghamton NY", description: "Second passport services for Binghamton defense contractors and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Patricia W.",
      location: "Vestal, NY",
      rating: 5,
      text: "Had a family emergency overseas and needed my passport within 3 days. Fast Passport Center delivered in 2. They walked me through every step since I was new to the whole process. Incredible peace of mind.",
      service: "Emergency Passport",
    },
    {
      name: "Michael T.",
      location: "Johnson City, NY",
      rating: 5,
      text: "Renewed my expired passport for a business trip to Toronto. Chose the expedited option and had it back in 4 days. They caught a photo issue I never would have noticed. Saved me a rejected application and weeks of delay.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Sarah L.",
      location: "Endicott, NY",
      rating: 5,
      text: "Needed a second passport while my primary was in visa processing for India. Fast Passport Center understood the urgency of my research trip. Had it in 5 days. As a BU researcher, I can't afford delays.",
      service: "Second Passport",
    },
    {
      name: "The Nguyen Family",
      location: "Binghamton, NY",
      rating: 5,
      text: "First-time passports for our two kids and one renewal for a family trip to Vietnam. The agent was incredibly patient with our questions. All three passports arrived together in 5 days. We'll use them for every renewal.",
      service: "Child Passport + Renewal",
    },
  ],
  facilities: [
    {
      id: "binghamton-1",
      name: "Binghamton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Chenango Street",
      city: "Binghamton",
      state: "NY",
      zip: "13901",
      phone: "(607) 772-2161",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Binghamton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Binghamton passport acceptance facility. First-time applicants must apply in person. Photo services available on-site. Book ahead — slots fill during SUNY semester start.",
      icon: "ri-mail-line",
    },
    {
      id: "binghamton-2",
      name: "Johnson City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "254 Floral Avenue",
      city: "Johnson City",
      state: "NY",
      zip: "13790",
      phone: "(607) 729-1191",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Johnson City — adjacent to Binghamton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Johnson City and west Binghamton residents. Passport acceptance by appointment. Fewer applicants than downtown — often faster appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "binghamton-3",
      name: "Vestal Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3301 Vestal Parkway East",
      city: "Vestal",
      state: "NY",
      zip: "13850",
      phone: "(607) 785-2205",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Vestal — south of Binghamton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Vestal, Endicott, Endwell, and south Binghamton communities. Passport acceptance available. Popular with SUNY Binghamton students — arrive early during semester transitions.",
      icon: "ri-mail-line",
    },
    {
      id: "binghamton-4",
      name: "Endicott Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Washington Avenue",
      city: "Endicott",
      state: "NY",
      zip: "13760",
      phone: "(607) 748-3016",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      distance: "Endicott — west of Binghamton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Endicott, Endwell, and Union Center communities. Convenient for IBM/Lockheed Martin area professionals. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "binghamton-5",
      name: "Broome County Clerk — Passport Services",
      type: "County Clerk Passport Acceptance",
      address: "60 Hawley Street, 2nd Floor",
      city: "Binghamton",
      state: "NY",
      zip: "13901",
      phone: "(607) 778-2451",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Binghamton",
      website: "https://www.gobroomecounty.com/clerk",
      websiteLabel: "Broome County Clerk",
      notes: "County government passport acceptance facility. Alternative to post office locations. No photo services on-site — bring your own 2x2 photos. Appointments strongly recommended.",
      icon: "ri-government-line",
    },
    {
      id: "binghamton-6",
      name: "SUNY Binghamton — Off Campus College Transport",
      type: "Student/Municipal Passport Acceptance",
      address: "4400 Vestal Parkway East, University Union",
      city: "Vestal",
      state: "NY",
      zip: "13850",
      phone: "(607) 777-2000",
      hours: "Mon–Fri 10:00 AM – 4:00 PM (academic year only)",
      distance: "SUNY Binghamton Campus — Vestal",
      website: "https://www.binghamton.edu/",
      websiteLabel: "SUNY Binghamton",
      notes: "Campus passport acceptance for students, faculty and staff. Limited to academic calendar. Best option for BU students needing first-time passports. Check university calendar for semester break closures.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to New York Passport Agency in Manhattan", fpc: "Most Binghamton travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Southern Tier Guidance", agency: "Generic — no SUNY, BGM airport, or Lockheed Martin expertise", fpc: "Full SUNY Binghamton/corporate/Southern Tier knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the New York Passport Agency Takes Walk-Ins",
      description: "The New York Passport Agency in Manhattan requires appointments even for emergencies. Many Binghamton residents arrive without an appointment after a 3-hour drive and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "SUNY Study Abroad Acceptance-to-Departure Crunch",
      description: "Binghamton University students often receive study abroad acceptance with just 4–8 weeks before departure. Standard post office processing at 8–11 weeks won't work. Expedited courier service is the only reliable path.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Broome County CVS and Walgreens locations produce photos that fail State Department standards — wrong background shade, head too large or small, shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Southern Tier families frequently overlook the DS-3053 consent form when one parent is unavailable to appear. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule on European Travel",
      description: "Binghamton travelers booking to Italy, Poland, or other European destinations often don't know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Binghamton clients ship from home or a local UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Binghamton?", a: "We offer Binghamton-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Binghamton office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Broome County post office or the County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Binghamton address." },
    { q: "Where can I get a passport acceptance in Binghamton?", a: "Binghamton has acceptance facilities at the Main Post Office on Chenango Street, the Broome County Clerk on Hawley Street, and post offices in Johnson City, Vestal, and Endicott. We maintain an updated list of Southern Tier facilities with hours, photo availability, and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency in Manhattan requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "What is the best price for expedited passport service in Binghamton?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Binghamton applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Binghamton-specific checklist." },
    { q: "Can I get a passport photo in Binghamton?", a: "Yes — many CVS, Walgreens, UPS Stores, and the Binghamton Post Office offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Binghamton passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Binghamton to final return shipping typically matches your chosen speed tier." },
    { q: "Is Binghamton near a passport agency?", a: "The closest passport agency is the New York Passport Agency at 376 Hudson Street, Manhattan — approximately 175 miles southeast. However, it only serves travelers with life-or-death emergencies. For standard expedited needs, our courier channel is faster and more accessible than agency appointments." },
    { q: "Can you help with passports for SUNY Binghamton study abroad?", a: "Yes. We regularly assist SUNY Binghamton students with expedited passports for study abroad programs across 70+ countries. We understand the academic calendar, acceptance-to-departure timelines (often just 4–8 weeks), and can coordinate processing around orientation dates." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Binghamton Residents",
    intro: "Binghamton's unique position in the Southern Tier — with a regional connector airport, a major public research university, and significant defense manufacturing — creates distinct passport timing challenges. Here's what Binghamton travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BGM — Greater Binghamton Airport",
        subtitle: "Regional connector airport serving the Southern Tier",
        description: "BGM connects Binghamton to major hubs like Detroit and Philadelphia. Most international travel from Binghamton involves a domestic connection through these gateways. The airport's limited schedule means a missed connection due to a passport issue can delay a trip by a full day or more. Students flying home to China, India, or Korea typically connect through DTW or PHL.",
        tip: "BGM connector flights to Detroit (Delta hub) are the most common international gateway for Binghamton travelers. Check your passport validity before booking the connector — once you're at DTW, there's no turning back.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SYR — Syracuse Hancock International Airport",
        subtitle: "75 miles north, closest full-service airport",
        description: "Syracuse Hancock offers direct flights to major U.S. cities and seasonal international service. Many Binghamton residents drive to SYR for more flight options. The 75-mile drive along I-81 means you need to factor in winter weather — a January trip through lake-effect snow can turn a 75-minute drive into a 3-hour ordeal. Planning passport processing around weather-affected departure windows is essential.",
        tip: "SYR is the best airport option for Binghamton travelers needing more flight choices. Book your passport processing at least 3 weeks before any winter departure — snow delays and lake-effect storms can compress your timeline.",
      },
      {
        icon: "ri-building-2-line",
        title: "Defense & Manufacturing Corporate Travel",
        subtitle: "Lockheed Martin, BAE Systems, United Health Services",
        description: "Binghamton's largest employers — Lockheed Martin (Owego), BAE Systems (Endicott), and UHS — generate significant international travel for contract work, supplier meetings, and global conferences. Defense contractors traveling to the UK, Australia, or NATO countries often book on short notice when contracts are signed. Manufacturing engineers heading to supplier facilities in Germany or Japan face fixed meeting dates that can't be moved.",
        tip: "Defense and manufacturing travel often involves countries with visa requirements that need passport details months in advance. Always check both passport validity and visa timelines simultaneously — getting the passport fast is step one, but visa processing adds its own clock.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY Binghamton Study Abroad & International Students",
        subtitle: "BU's 70+ country programs and 1,800+ international students",
        description: "Binghamton University sends hundreds of students abroad each year for semester exchange, summer programs, and faculty-led trips. Many of these students — especially first-generation college students from the Southern Tier — have never held passports. International students at BU also frequently need passport renewals from their home countries, creating complex dual-country documentation scenarios. The acceptance-to-orientation pipeline is often 4–8 weeks, necessitating expedited processing.",
        tip: "BU study abroad acceptance letters often arrive with just 4–8 weeks before departure. First-time passport applicants need an acceptance facility visit — we help students find the earliest available appointment near campus.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Southern Tier Heritage Travel & Niagara Falls Crossings",
      description: "Binghamton has deep Polish, Italian, and Irish heritage communities — exactly the kind of travelers booking first trips to Europe to visit ancestral hometowns. The proximity to Niagara Falls and the Canadian border (about 3.5 hours) also creates regular passport demand for Toronto weekend trips, cross-border shopping, and Canadian tourism. Many first-time passport applicants in Binghamton are families planning their first trip to Italy, Ireland, or Poland.",
    },
  },
  destinations: {
    title: "Where Binghamton Travelers Go — And Why Passports Get Urgent",
    intro: "Binghamton's mix of university students, defense contractors, and heritage communities means passports are needed for destinations spanning five continents. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Binghamton expedited requests are university-related — study abroad, international students, faculty conferences" },
      { stat: "4–8 Weeks", label: "average lead time from SUNY study abroad acceptance to international departure" },
      { stat: "Nov–Jan", label: "peak season when spring semester study abroad, winter break family travel, and corporate year-end travel collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a BU student departing to London" },
    ],
    destinations: [
      { name: "Italy", context: "Heritage travel to ancestral towns in Sicily and Campania, SUNY Florence programs, family reunions", urgency: "Summer bookings peak March through May with tight acceptance timelines", icon: "ri-map-pin-2-line" },
      { name: "Poland & Eastern Europe", context: "Deep Polish-American heritage in Binghamton and Johnson City, ancestry trips to Kraków and Warsaw", urgency: "Multi-generational family trips booked 2–3 months out — but often passports discovered expired at booking", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SUNY London programs, Lockheed Martin UK contract travel, Irish heritage tourism", urgency: "Business and study abroad travel often booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "China & East Asia", context: "BU's large international student population from China and Korea, faculty research exchanges", urgency: "Passport renewals needed for students returning home during breaks", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto weekend trips from the Southern Tier, Niagara Falls crossings, cross-border family connections", urgency: "Weekend trips booked on impulse — realized passport expired at the border", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "BAE Systems and Lockheed Martin supplier travel, SUNY Berlin programs, heritage tourism", urgency: "Contract travel with fixed meeting dates and 1–2 week booking windows", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Syracuse", route: "/syracuse" },
      { name: "Ithaca", route: "/ithaca" },
      { name: "Albany", route: "/albany-ny" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Vestal Parkway", address: "2541 Vestal Pkwy E, Vestal, NY 13850", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Main Street", address: "53 Main St, Binghamton, NY 13905", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Front Street", address: "1276 Front St, Binghamton, NY 13901", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Vestal", address: "3701 Vestal Pkwy E, Vestal, NY 13850", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Endicott", address: "101 Nanticoke Ave, Endicott, NY 13760", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Vestal", address: "2405 Vestal Pkwy E, Vestal, NY 13850", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/cp/photo/1076964" },
    { name: "FedEx Office — Vestal", address: "4700 Vestal Pkwy E, Vestal, NY 13850", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walgreens — Johnson City", address: "349 Main St, Johnson City, NY 13790", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Binghamton",
      address: "33 Lewis Street, Binghamton, NY 13901",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Endicott",
      address: "3210 North Street, Endicott, NY 13760",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving Endicott, Endwell, and Union Center residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BGM",
      name: "Greater Binghamton Airport",
      distance: "About 10 miles north of downtown Binghamton",
      address: "2534 Airport Road, Johnson City, NY 13790",
      note: "Regional connector airport with Delta flights to Detroit. Primary international gateway for SUNY Binghamton students and Southern Tier business travelers connecting through DTW.",
      flightUrl: "https://www.flybgm.com/",
      flightLabel: "BGM Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "About 75 miles north of Binghamton",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Upstate New York's major airport with flights to major U.S. hubs and seasonal international service. Best option for Binghamton travelers needing more flight choices.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Broome County residents can also contact the Broome County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Broome County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Broome County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.gobroomecounty.com/clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Broome County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default binghamtonConfig;